export const districtScreenerIntroSteps = [
  {
    element: '#printButton',
    intro: 'Click here to print the Screener School Report.'
  },
  {
    element: '.report',
    intro: 'Screener is where you can find overview information on the WordFlight Screener. You can see the Screener enrollment, completion, and results at the school level. You can also see the percentage of students who have completed the Screener sorted by teacher.'
  },
  {
    element: '#district-report-screener-enrollment',
    intro: 'See your school’s Screener enrollment data. See how many students are enrolled in the WordFlight Screener.'
  },
  {
    element: '#district-report-screener-completion',
    intro: 'See the percentage of students who have completed the WordFlight Screener.'
  },
  {
    element: '#district-report-screener-performance',
    intro: 'See the percentage of students and number of students in each risk category. The WordFlight Screener sorts students into three risk categories: High Risk, Some Risk, and Proficient.'
  },
  {
    element: '.district-report-row:nth-child(3)',
    intro: 'Click the plus sign to view WordFlight Screener data sorted by teacher. See the teacher’s name, the grades they teach, their school, and the percentage of their students who have completed the WordFlight Screener.'
  }
];